<script>
  import { api, cutText } from '../../helpers'

  export let doc
  export let id_publicate
  export let id

  const title = doc?.split('/')?.slice(-1)?.join() || ''

  const logAFile = async () => {
    if (!title.toLowerCase().includes('summary')) {
      return
    }

    const path = '/api/v1/logging/publication/create/click-file/'
    const method = 'POST'
    const isJSON = true
    const body = JSON.stringify({ publication: +id_publicate, publication_item: +id })

    await api(path, method, body, isJSON)
  }
</script>

<div class="main__dog">  
  <div class="main__doc__text">
    <a 
      class="link__doc text-bold" 
      href={doc} 
      target="_blank"
      on:click={logAFile}
    >
      <i class="icon-file" />
      <span class="title__doc text-bold">{cutText(title)}</span>
    </a>
  </div>
</div>

<style>
  .icon-file {
    font-size: 15px;
  }
.main__dog {
  width: 100%;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  flex-wrap: wrap;
  flex-direction: row;
  margin-bottom: 16px;
}

.link__doc{
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  font-style: normal;
  font-size: 10px;
  line-height: 14px;
  color: #2B50ED;
  fill: #2B50ED; 
  cursor: pointer;  
  text-decoration: none;
}

.title__doc{
  padding-left: 7px;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient:horizontal;
  -webkit-box-direction:normal;
  -webkit-box-align:center;
  -ms-flex-align:center;
  align-items:center;
  font-style: normal;
  font-size: 12px;
  line-height: 14px;
  color: #2B50ED;
  fill: #2B50ED; 
  cursor: pointer;  
  text-decoration: none;
  word-break: break-word;
}

@media (max-width: 500px){
  .main__dog{
    margin: 0 0 10px 0;
  }
  }
</style> 
